import React, { useEffect, useState } from "react";
import "./EquipePremiere.css";

import galerie1 from "../assets/images/galerieR1_1.jpg";
import galerie2 from "../assets/images/galerieR1_2.jpg";
import galerie3 from "../assets/images/galerieR1_3.jpg";
import galerie4 from "../assets/images/galerieR1_4.jpg";
import Effectif from "../components/Effectif/Effectif";
import Classement from "../components/Classement/Classement";
import MatchCard from "../components/MatchCard/MatchCard"; // Réutilisation du composant MatchCard
import { fetchTeamMatches } from "../ServiceApi"; // Import de la fonction fetch
import config from "../config";
import responsablesData from "../assets/data/responsables.json";
import ResponsablesSection from "../components/ResponsablesSection/ResponsablesSection";
import heroDesktop from "../assets/images/sections/hero_desktop_2026.jpg";
import heroMobile from "../assets/images/sections/hero_mobile_2026.jpg";

const EquipePremiere = () => {
    const [players, setPlayers] = useState([]);
    const [stats, setStats] = useState([]);
    const [upcomingMatches, setUpcomingMatches] = useState([]);
    const [playedMatches, setPlayedMatches] = useState([]);

    const [responsables, setResponsables] = useState([]);
    // États pour gérer les sections pliables
    const [activeTab, setActiveTab] = useState('calendar'); // 'calendar', 'results', 'ranking'
    const [isRankingOpen, setIsRankingOpen] = useState(false);
    const [isResultsOpen, setIsResultsOpen] = useState(false);

    const { team } = config;

    useEffect(() => {
        // Simulation des appels API pour les joueurs et statistiques
        setPlayers([]);
        setStats([
            { title: "Club le plus titré de France", value: "12", description: "Titres nationaux remportés" },
            { title: "Participations à la Champions League", value: "5", description: "Participations" },
            { title: "Record d’invincibilité", value: "117", description: "Matchs sans défaite" },
            { title: "Record d’invincibilité à domicile", value: "81", description: "Matchs à domicile sans défaite" },
        ]);

        // Récupération des matchs de la compétition
        const fetchMatches = async () => {
            const competitionId = 441214; // ID de la compétition "D2"
            const phaseId = 1; // ID de la phase
            const pouleId = 1; // ID de la poule
            const clubId = team.id; // ID du club

            const matches = await fetchTeamMatches(competitionId, phaseId, pouleId, clubId);

            // Filtrage des matchs : Joués et à venir
            const played = matches.filter(
                (match) => match.home_score !== null && match.away_score !== null
            ).reverse(); // Inverser pour avoir les plus récents en premier
            const upcoming = matches.filter(
                (match) => match.home_score === null && match.away_score === null
            );

            setPlayedMatches(played);
            console.log("played", played);
            setUpcomingMatches(upcoming);
        };

        // Charger les responsables à partir du fichier JSON importé
        const fetchResponsables = () => {
            const teamResponsables = responsablesData['Sénior 1'] || [];
            setResponsables(teamResponsables);
        };

        fetchResponsables();
        fetchMatches();
    }, []);

    return (
        <div className="equipe-premiere" data-aos="fade-up">
            {/* Bandeau Introductif */}
            <section className="intro-equipe-premiere">
                <picture className="hero-bg-wrapper">
                    <source media="(max-width: 768px)" srcSet={heroMobile} />
                    <img src={heroDesktop} alt="Équipe Première Nantes Doulon Bottière Futsal" className="hero-bg-image" />
                </picture>
                <div className="intro-equipe-premiere-overlay">
                    <div className="intro-content">
                        <h1>Équipe Première</h1>
                        <h2 className="intro-subtitle">Saison 2025/2026 • D2 Futsal</h2>
                        <div className="intro-actions">
                            <a href="/" className="back-button">
                                <span className="back-arrow">←</span> Retourner au Club
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            {/* Statistiques Clés */}
            {/*<section className="stats">
                <div className="stats-container">
                    {stats.map((stat, index) => (
                        <div key={index} className="stat-card">
                            <h2>{stat.value}</h2>
                            <h3>{stat.title}</h3>
                            <p>{stat.description}</p>
                        </div>
                    ))}
                </div>
            </section>*/}


            {/* Section Responsables */}
            <ResponsablesSection responsables={responsables} />

            {/* Présentation des Joueurs */}
            <Effectif />

            {/* Section Contenu Principal (2 colonnes) */}
            <div className="main-content-grid">

                {/* Colonne Gauche : Calendrier et Classement */}
                <div className="left-column">
                    <h2 className="section-title">Calendrier et Classement</h2>

                    <div className="tabs-container">
                        <button
                            className={`tab-button ${activeTab === 'calendar' ? 'active' : ''}`}
                            onClick={() => setActiveTab('calendar')}
                        >
                            Calendrier
                        </button>
                        <button
                            className={`tab-button ${activeTab === 'results' ? 'active' : ''}`}
                            onClick={() => setActiveTab('results')}
                        >
                            Derniers Résultats
                        </button>
                        <button
                            className={`tab-button ${activeTab === 'ranking' ? 'active' : ''}`}
                            onClick={() => setActiveTab('ranking')}
                        >
                            Classement
                        </button>
                    </div>

                    <div className="tab-content">
                        {activeTab === 'ranking' && (
                            <div className="ranking-wrapper">
                                <Classement competitionId={441214} showTitle={false} />
                            </div>
                        )}

                        {activeTab === 'calendar' && (
                            <div className="matches-wrapper">
                                {upcomingMatches.length > 0 ? (
                                    upcomingMatches.map((match) => (
                                        <MatchCard key={match.ma_no} match={match} />
                                    ))
                                ) : (
                                    <p className="no-results">Aucun match à venir.</p>
                                )}
                            </div>
                        )}

                        {activeTab === 'results' && (
                            <div className="matches-wrapper">
                                {playedMatches.length > 0 ? (
                                    playedMatches.map((match) => (
                                        <MatchCard key={match.ma_no} match={match} />
                                    ))
                                ) : (
                                    <p className="no-results">Aucun résultat disponible.</p>
                                )}
                            </div>
                        )}
                    </div>
                </div>

                {/* Colonne Droite : Galerie et Contact */}
                <div className="right-column">
                    {/* Widget Galerie */}
                    <div className="widget-box gallery-widget">
                        <div className="widget-header">
                            <h3>Voir galerie complète</h3>
                            <a href="/medias" className="widget-link">Voir tout →</a>
                        </div>
                        <div className="mini-gallery-grid">
                            <a href="/medias"><img src={galerie1} alt="Galerie 1" /></a>
                            <a href="/medias"><img src={galerie2} alt="Galerie 2" /></a>
                            <a href="/medias"><img src={galerie3} alt="Galerie 3" /></a>
                        </div>
                    </div>

                    {/* Widget Contact */}
                    <div className="widget-box contact-widget">
                        <p>
                            Vous souhaitez rejoindre au soutenir le club ? <br />
                            <span className="highlight-text">Contactez-nous</span> des maintenant !
                        </p>
                        <a href="/contact" className="contact-button">CONTACTER</a>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default EquipePremiere;
